import React from "react";
import {
  CButton,
  CCol,
  CModal,
  CFormGroup,
  CInputCheckbox,
  CLabel,
  CModalBody,
  CModalFooter,
} from "@coreui/react";
import ApoDocHdwtRegPop from "./apoDocHdwtRegPop";
import { useSelector } from "react-redux";

const ApoDocFormPop = (props) => {
  const state = useSelector((state) => state);
  const {  hashValue  } = state.main;
  let {  corpNm  } = state.main;
  const afcrNo = Number(props.afcrNo);
  const [hdwtRegPop, setHdwtRegPop] = React.useState({
    isOpen: false,
  });
  const imgName = {
    10001: ["APO_DOC_10001"],
    10002: ["APO_DOC_10002"],
    10003: ["APO_DOC_10003"],
    10004: ["APO_DOC_10004"],
    10005: ["APO_DOC_10005_A", "APO_DOC_10005_B"],
    10006: ["APO_DOC_10006"],
    10007: ["APO_DOC_10007"],
    10008: ["APO_DOC_10008"],
    10009: ["APO_DOC_10009_A", "APO_DOC_10009_B"],
    10010: ["APO_DOC_10010"],
    10011: ["APO_DOC_10011"],
    10012: ["APO_DOC_10012"],
    10013: ["APO_DOC_10013"],
    10021: ["APO_DOC_10021"],
    10022: ["APO_DOC_10022"],
    10023: ["APO_DOC_10023"],
    10026: ["APO_DOC_10026"],
    10027: ["APO_DOC_10027"],
    10028: ["APO_DOC_10028"],
    10029: ["APO_DOC_10029"],
    10030: ["APO_DOC_10030"],
    10031: ["APO_DOC_10031"],
    90001: ["QLFC_DOC_02"],
    20001: ["APO_DOC_20001"],
    20006: ["APO_DOC_20006"],
    20007: ["APO_DOC_20007"],
    20021: ["APO_DOC_20021"],
  };


 //스카이블루에셋 / 외국내국인 미리보기 분기 (한화/푸본)
 if(corpNm == 'sky' && hashValue == '#F' && (afcrNo == 10022 || afcrNo == 10005 )){
  corpNm = corpNm + '_F';
 }
  return (
    <>
       
      {( ((afcrNo === 10009) || (afcrNo === 10005)) && (corpNm !== 'gfk' && corpNm !== 'mfs' && corpNm !== 'GLOBAL' && corpNm !=='megainfo'&& corpNm !=='sky' && corpNm !=='sky_F')) ? (
        <CModal
          className={hdwtRegPop.isOpen ? "hideContent" : "showContent"}
          show={true}
          size="lg"
          closeOnBackdrop={false}
          onClosed={() => {
            props.onClose();
          }}
        >
          <CModalBody className="apoModalBody">
            <CFormGroup row>
              <img
                src={`/images/apoDocForm/${corpNm}_${imgName[afcrNo][0]}.jpg`}
                alt={imgName[afcrNo][0]}
                width="100%"
              />
            </CFormGroup>
            {(corpNm !== 'gfk' && corpNm !== 'megainfo' && corpNm !== 'sky' && corpNm !== 'sky_F') &&
              <CFormGroup row className="signBtn">
                <CCol xs="8" className="text-left">
                  <CFormGroup variant="checkbox" className="checkbox">
                    <CInputCheckbox
                      id={`${afcrNo}chk`}
                      name={`${afcrNo}chk`}
                      checked={
                        afcrNo === 10009
                          ? state.apoDocForm.apoDocHdwtInfo[1].data
                            ? true
                            : false
                          : state.apoDocForm.apoDocHdwtInfo[2].data
                          ? true
                          : false
                      }
                      readOnly
                    />
                    <CLabel variant="checkbox" className="form-check-label">
                      <b>
                        {afcrNo === 10009
                          ? `종이문서, 휴대전화`
                          : `모든 내용을 숙지하고 동의`}
                      </b>
                    </CLabel>
                  </CFormGroup>
                </CCol>
                <CCol xs="4">
                  <button className="btn-footer" type="button"
                    onClick={() =>
                      setHdwtRegPop({
                        isOpen: true,
                      })
                    }
                    disabled={
                      state.insert.reqTaskInfo.stCd === "10" ||
                      state.insert.reqTaskInfo.stCd === "99"
                        ? false
                        : true
                    }
                  >
                    자필작성
                  </button>
                </CCol>
              </CFormGroup>
            }
            <CFormGroup row>
              <img
                src={`/images/apoDocForm/${corpNm}_${imgName[afcrNo][1]}.jpg`}
                alt={imgName[afcrNo][1]}
                width="100%"
              />
            </CFormGroup>
          </CModalBody>
          <CModalFooter>
           <div className="layout-footer">
              <button className="btn-footer" type="button" 
              onClick={() => {
                props.onClose(afcrNo);
              }}>
                확인
              </button>
            </div>
          </CModalFooter>
        </CModal>
      ) : (
        <CModal
          className={hdwtRegPop.isOpen ? "hideContent" : "showContent"}
          show={true}
          size="lg"
          closeOnBackdrop={false}
          onClosed={() => {
            props.onClose();
          }}
        >
          <CModalBody className="apoModalBody">
            <CFormGroup row>
              <img
                src={
                  imgName[afcrNo] !== undefined
                    ? `/images/apoDocForm/${corpNm}_${imgName[afcrNo][0]}.jpg`
                    : null
                }
                alt={imgName[afcrNo] !== undefined ? imgName[afcrNo][0] : null}
                width="100%"
              />
            </CFormGroup>
          </CModalBody>
          <CModalFooter>
            <div className="layout-footer">
              <button className="btn-footer" type="button" 
              onClick={() => {
                props.onClose(afcrNo);
              }}>
                확인
              </button>
            </div>
          </CModalFooter>
        </CModal>
      )}
      {hdwtRegPop.isOpen && (
        <ApoDocHdwtRegPop
          modal={true}
          etcYn={afcrNo === 10009 ? 1 : 2}
          display={hdwtRegPop.isOpen ? "display" : ""}
          onClose={() => setHdwtRegPop({ isOpen: false })}
        ></ApoDocHdwtRegPop>
      )}
    </>
  );
};

export default ApoDocFormPop;
